import PageHero from '../../components/PageHero';
import './PhotosPage.css';

function PhotosPage() {
  // Collage layout: size = 'small' | 'medium' | 'large' (grid span)
  const photos = [
    { id: 1, src: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800', alt: 'Wedding ceremony', size: 'large', caption: 'Ceremony' },
    { id: 2, src: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=600', alt: 'Reception decor', size: 'medium', caption: 'Reception' },
    { id: 3, src: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=600', alt: 'Bridal portrait', size: 'medium', caption: 'Portrait' },
    { id: 4, src: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800', alt: 'Mandap setup', size: 'large', caption: 'Mandap' },
    { id: 5, src: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=600', alt: 'Couple portrait', size: 'tall', caption: 'Couple' },
    { id: 6, src: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=600', alt: 'Floral decor', size: 'medium', caption: 'Florals' },
    { id: 7, src: 'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=800', alt: 'Wedding venue', size: 'wide', caption: 'Venue' },
    { id: 8, src: 'https://images.unsplash.com/photo-1523438885200-e635ba2c371e?w=600', alt: 'Celebration', size: 'medium', caption: 'Celebration' },
    { id: 9, src: 'https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=600', alt: 'Wedding cake', size: 'medium', caption: 'Cake' },
    { id: 10, src: 'https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=800', alt: 'Bridal details', size: 'large', caption: 'Details' },
    { id: 11, src: 'https://images.unsplash.com/photo-1583939003579-730e3918a45a?w=600', alt: 'Decor', size: 'small', caption: 'Decor' },

  ];

  return (
    <div className="photos-page">
      <PageHero
        title="Wedding Photos"
        subtitle="Real moments from real celebrations — get inspired for your big day"
      />
      <div className="photos-page__section">
        <p className="photos-page__intro">
          From intimate ceremonies to grand receptions, explore our collection of stunning wedding moments.
        </p>
        <div className="photos-collage">
          {photos.map((photo) => (
            <figure
              key={photo.id}
              className={`photos-collage__item photos-collage__item--${photo.size}`}
            >
              <div className="photos-collage__frame">
                <img
                  src={photo.src}
                  alt={photo.alt}
                  className="photos-collage__img"
                  loading="lazy"
                />
                <div className="photos-collage__overlay">
                  <span className="photos-collage__caption">{photo.caption}</span>
                </div>
              </div>
            </figure>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PhotosPage;
